<div class="send-section">
  <div class="message-section">
    <mat-form-field class="message-input" subscriptSizing="dynamic">
      <mat-label>{{'NEW_COMMENT' | translate}}</mat-label>
      <textarea [(ngModel)]="sendCommentOnly"
                matInput
                #inputonly
                [escapeAwareMaxLength]="1000">
            </textarea>
      <mat-hint align="end">{{inputonly.value | escapeAwareCharCount}}/1000</mat-hint>
    </mat-form-field>
    <div id="commentSection" class="message-button">
      <button mat-icon-button [ngClass]="sendCommentOnly.length < 1 ? 'message-icon-disabled' : 'message-icon-active'"
              (click)="sendCommentRequest()"
              [disabled]="sendCommentOnly.length<1">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="list-section" *ngIf="!isUplading">
  <p *ngIf="!comments || comments.length === 0">
    <i>{{'THERE_ARE_NO_COMMENTS' | translate}}</i>
  </p>
  <div class="item" *ngFor="let comment of comments">
    <div class="comment-header">
      <div class="comment-badge-circle">{{getInitials(comment.userName)}}</div>
      <span class="user-name">{{comment.userName}}</span>
      <span class="example-spacer"></span>
      <span class="date">{{dateFormatting(comment.date, false)}}</span>
    </div>
    <div class="comment-body">{{comment.comment}}</div>
  </div>
</div>
